import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findAccountDetails = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_detail/details?` + params,
        method: 'GET'
    })
}
export const findAccountDetailsDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_detail/downloadExcel?` + params,
        method: 'GET'
    })
}